/**
 * Error codes returned in the API envelope's inner payload
 * (`res.data.data.code`). Shared across b2c and backoffice so both can react
 * to the same structured backend errors (e.g. refresh-rates "room no longer
 * available"). Always treat the code as OPTIONAL — older responses and
 * non-hotel providers may omit it.
 */
export enum ErrorCode {
  MISSING_DATA = 'missing_data',
  DEFAULT_ERROR = 'default_error',
  ROOM_NOT_AVAILABLE = 'room_not_available',
}

/**
 * Codes from the PHP API, which numbers its error codes (see
 * ApiManager.php) rather than using the string codes above.
 *
 * These are returned by `/supplier/order/assignOrderToAgency` when an order is
 * reassigned to another agency/agent.
 */
export enum AssignOrderToAgencyErrorCode {
  AGENCY_REQUIRED = 4901,
  AGENCY_NOT_FOUND = 4902,
  AGENT_NOT_FOUND = 4903,
  AGENT_NOT_IN_AGENCY = 4904,
  ALREADY_ASSIGNED = 4905,
  DIAMONDS_MIGRATION_FAILED = 4906,
}
